<template>
  <DialogDemoLeave v-model:visibility="showLeaveDemo" />
  <div class="header-menu no-print">
    <TheAutomaticLogoutTimer
      v-if="
        preferenceStore.preferences?.automatic_logout_time &&
        preferenceStore.preferences?.automatic_logout_time > 0
      "
      class="logout-timer"
      :logout-time="preferenceStore.preferences.automatic_logout_time" />

    <!-- Demo data switch -->
    <SmButton
      v-if="sessionStore.currentCompanyInfo?.demo"
      class="leave-demo-button"
      :text="i18n.t('headerMenu.realDataButton')"
      type="primary"
      @click="showLeaveDemo = true" />

    <SmTooltip placement="bottom" :delay="1000">
      <template #content>
        {{
          preferenceStore.preferences?.appearance === 'dark_theme'
            ? i18n.t('headerMenu.settings.colorTheme.light')
            : i18n.t('headerMenu.settings.colorTheme.dark')
        }}
      </template>

      <component
        :is="
          preferenceStore.preferences?.appearance === 'dark_theme' ? Sun : Moon
        "
        :size="24"
        class="stroke-contrast-muted hover:stroke-contrast"
        style="cursor: pointer"
        @click="handleDarkModeChange" />
    </SmTooltip>

    <NotificationInbox v-if="sessionStore.status === 'LOGGED_IN'" />

    <SmTooltip placement="bottom" :delay="1000">
      <template #content>
        {{ i18n.t('settings') }}
      </template>
      <Settings
        :size="24"
        class="stroke-contrast-muted hover:stroke-contrast"
        style="cursor: pointer"
        @click="openDialog('settings')" />
    </SmTooltip>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { Moon, Sun, Settings } from 'lucide-vue-next'

  import { usePreferenceStore } from '@/stores/preferenceStore'

  import { useSessionStore } from '@/stores/sessionStore'

  import { openDialog } from '@/utils/dialogManager'

  const i18n = useI18n()
  const preferenceStore = usePreferenceStore()
  const sessionStore = useSessionStore()

  // Leave demo data
  const showLeaveDemo = ref(false)

  const handleDarkModeChange = () => {
    preferenceStore.toggleColorMode()
  }
</script>

<style scoped>
  .icon-left {
    margin-right: 0.5rem;
  }

  .header-menu {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
  }
</style>
